import { Campaign, CampaignTypes } from '@/models';
import { Routes } from '@/router';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardExtrasCampaignDetailModal',
})
export default class CmgRewardExtrasCampaignDetailModal extends Vue {
  get campaign(): Campaign {
    return this.$appStore.state.ui.modals.rewardExtrasCampaignDetail.args!.campaign;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.rewardExtrasCampaignDetail.visible;
  }

  get isExtra(): boolean {
    return this.campaign.campaignType === CampaignTypes.Extra;
  }

  get expirationDate(): string {
    if (this.campaign.endDate) {
      return new Date(this.campaign.endDate).toLocaleDateString();
    }

    return '';
  }

  get ctaText(): string {
    if (this.campaign.ctaType.toLowerCase() == 'grouporder') {
      return 'START A GROUP ORDER';
    } else if (this.campaign.ctaType.toLowerCase() == 'order') {
      return 'START AN ORDER';
    }

    return '';
  }

  get moreOrders(): string {
    const stepsNeeded = this.campaign.totalNumberOfSteps - this.campaign.currentStep;
    return stepsNeeded + ' more ' + (stepsNeeded > 1?  'orders' : 'order');
  }

  get backgroundImageUrl(): string {
    return 'url(\'' + this.campaign.mediaUri + '\')';
  }

  onClose() {
    this.$services.ui.setModalVisibility('rewardExtrasCampaignDetail', false);
  }

  onClickTermsAndConditions() {
    const campaign = this.campaign;
    const onBack = () => {
      this.$services.ui.setModalVisibility('rewardExtrasCampaignDetail', true, { campaign });
      this.$services.ui.setModalVisibility('rewardTermsAndConditions', false);
    };

    this.$services.ui.setModalVisibility('rewardTermsAndConditions', true, { termsAndConditions: this.campaign.terms, onBack });
    this.$services.ui.setModalVisibility('rewardExtrasCampaignDetail', false);
  }

  onClickCta() {
    switch (this.campaign.ctaType) {
      case 'GroupOrder':
        this.$router.push({ name: Routes.GroupOrderCreate });
        break;
      case 'Order':
        this.$router.push({ name: Routes.Order, hash: '#menu' });
        break;
      default:
    }

    this.onClose();
  }
}